import React, {Component} from 'react';
import { Dialog } from 'primereact/dialog';
export class Manual extends Component{
    constructor(){
        super();
        this.state ={
         mostrarModal:false,
         mostrarModalConRegistro:false,
        };
    }
    mostrarElModal = () => {
        this.setState({mostrarModal:true});
    }
    cerrarElModal = () => {
        this.setState({mostrarModal:false});
    }
    mostrarModalConRegistro = () =>{
        this.setState({mostrarModalConRegistro:true});
    }
    cerrarModalConRegistro = () =>{
        this.setState({mostrarModalConRegistro:false});
    }
    render(){
        const{mostrarModal, mostrarModalConRegistro} = this.state;
        return(
        <div>
              <a style={{ color: '#317f43' }} onClick={this.mostrarElModal}>Manual de Usuario sin registro |</a>
              <a style={{ color: '#317f43' }} onClick={this.mostrarModalConRegistro}> Manual de Usuario Con registro</a>
              <div >
                <Dialog appendTo={document.body} header={'Manual de Usuario Sin Registro'} visible={mostrarModal} modal={true} onHide={this.cerrarElModal} >
                    <div>
                        <iframe width="560" height="315" src="FacturacionSinRegistro.pdf" title="title" frameborder="0" allowfullscreen>
                        </iframe>
                    </div>
                </Dialog>
                <Dialog appendTo={document.body} header={'Manual de Usuario Con Registro'} visible={mostrarModalConRegistro} modal={true} onHide={this.cerrarModalConRegistro} >
                    <div>
                        <iframe width="560" height="315" src="FacturacionConRegistro.pdf" title="title" frameborder="0" allowfullscreen>
                        </iframe>
                    </div>
                </Dialog>
               

                </div>
        </div>
        );
    }
}
export default Manual;